<template>
    <div class="installt">
        <div class="intext">资金管理</div>
        <!-- <div class="addpoper" @click="openDialog">
            <div> <el-icon :size="24" color="#fff">
                    <Plus style=" margin-right: 8px" />
                </el-icon></div>
            <div style="height: 24px;">添加商铺</div>
        </div> -->
    </div>
    <div class="shops">
        <div class="shopslei">
            <el-tabs v-model="activeName" class="demo-tabs">
                <el-tab-pane label="资金流入" name="first">
                    <CapitalRu></CapitalRu>

                </el-tab-pane>

            </el-tabs>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import CapitalChu from '@/components/capital/CapitalChu.vue';
import CapitalRu from '@/components/capital/CapitalRu.vue';
import storeapi from '@/api/store'
let addstorekey = ref('')
let addstorelist = ref([])
onMounted(() => {

});

//添加搜索
const addstore = async () => {
    try {
        let data = {
            "keyword": addstorekey.value,
            "keywordType": 1
        }
        const res = await storeapi.StoreAddkey(data)
        console.log('添加搜索', res)
        addstorelist.value = res.data.records
    } catch {

    }
}




const activeName = ref('first')


</script>

<style lang="scss" scoped>
::v-deep .el-pagination {
    position: absolute;
    bottom: 15px;
    right: 34px;


    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .demo-tabs {

    height: 100%;

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__nav-scroll {

        .el-tabs__nav {

            .el-tabs__item {
                height: 60px !important;
                margin-right: 61px;
            }
        }
    }

    .el-tabs__content {
        height: calc(100% - 60px);
    }

    #tab-first {
        margin-left: 24px !important;
    }
}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
}

.shops {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .shopslei {
        height: 100%;
    }
}

.dialog {
    position: relative;
    width: 380px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
    }



    .search {
        width: 100%;
        height: 48px;
        margin-right: 24px;
        background: #F8F8F8;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 14px auto;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #F8F8F8;

        }

    }

    .nextgroom {
        height: 440px;
        overflow: auto;

        .rooms {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;


            .userh {
                display: flex;
                width: 334px;


                .userhs {
                    width: 56px;
                    height: 56px;
                    border-radius: 28px;
                    background-color: #d4d0d0;
                    margin-right: 10px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .username {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    font-size: 17px;

                    .memng {
                        font-size: 14px;
                        font-weight: 400;
                        color: #4D585F;
                        width: 100%;
                    }
                }
            }

            .norooms {
                width: 102px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border-radius: 8px;
                border: 1px solid #0291FE;
                font-size: 16px;
                font-weight: 400;
                color: #0091FF;
                cursor: pointer;
            }
        }
    }


}
</style>